module.exports = __webpack_public_path__ + "img/number.482abf2.png";